<template lang="pug">
.change-status-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('changeStatusTemplate.title') }}
    v-row
      v-col(cols="6")
        v-select(
          :label="$t('changeStatusTemplate.entity')",
          :value="(value || {}).entity",
          :items="schema",
          item-text="name",
          item-value="name",
          @input="selectEntity",
        )
      v-col(cols="6")
        v-select(
          v-if="(value || {}).entity",
          :label="$t('changeStatusTemplate.status')",
          :value="(value || {}).statusExtId",
          :items="filteredStatuses",
          item-text="name",
          item-value="externalId",
          :loading="statusLoading",
          @input="selectStatus",
        )
</template>

<script>
import axios from 'axios'

export default {
  props: ['value', 'template'],
  data () {
    return {
      statuses: [],
      statusLoading: true,

      contentTemplate: {
        entity: '',
        identifier: '@Model.Uid',
        statusExtId: '',
        isRazor: true
      },
    }
  },
  computed: {
    schema() {
      return this.$store.state.schema.all;
    },
    filteredStatuses() {
      return this.value && this.value.entity ? this.statuses.filter(s => s.entity == String(this.value.entity)) : [];
    },
  },
  methods: {
    selectEntity(val) {
      const input = { ...this.contentTemplate, ...this.value, entity: val, statusExtId: '' };
      this.$emit('input', input);
    },
    selectStatus(val) {
      const input = { ...this.contentTemplate, ...this.value, statusExtId: val };
      this.$emit('input', input);
    },
  },
  async created () {
    try {
      this.statuses = (await axios.get('Statuses', {params: { pageSize: -1 }})).data.data;
    } catch(error) {
      console.log(this.$cleanString(error));
    } finally {
      this.statusLoading = false;
    }
  },
}
</script>
